<template>
  <page>
          <v-expansion-panels v-model="panel1" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Selection Criteria
              </div>
            </v-expansion-panel-header>
              <v-expansion-panel-content>
    <v-container fluid grid-list-md>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <!-- <v-toolbar dense color="grey lighten-3" flat>
              <v-icon>mdi-file-document-box</v-icon>
              <v-toolbar-title>Gross & RI Ceded Statistics</v-toolbar-title>
            </v-toolbar> -->
            <v-card-text>
              <message :messages="messages"></message>
              <v-layout row wrap>
                <v-flex xs12 md6>
                  <v-text-field v-model="form.acctPerFrom" :label="labels.acctPerFrom"
                    :error-messages="errors.collect('acctPerFrom')" :data-vv-as="labels.acctPerFrom"
                    data-vv-name="acctPerFrom" append-icon="mdi-magnify" @click:append="getHelpList('acctPerFrom')"
                    readonly v-validate="acctPeriodValidate('acctPerFrom')">
                  </v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field v-model="form.acctPerTo" :label="labels.acctPerTo"
                    :error-messages="errors.collect('acctPerTo')" :data-vv-as="labels.acctPerTo"
                    data-vv-name="acctPerTo" append-icon="mdi-magnify" @click:append="getHelpList('acctPerTo')" readonly
                    v-validate="acctPeriodValidate('acctPerTo')">
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
          </v-expansion-panels>
          <v-spacer class="mt-3"></v-spacer>
          <v-expansion-panels v-model="panel1" multiple>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filter
              </div>
            </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-container fluid grid-list-md>
                <v-layout row wrap>
                  <v-flex xs12>
                    <v-card>
                    <v-card-text>
                      <v-layout row wrap>
                        <v-flex xs12 md6>
                          <v-text-field v-model="form.fund" :label="labels.fund"
                            :error-messages="errors.collect('fund')" :data-vv-as="labels.fund" data-vv-name="fund"
                            append-icon="mdi-magnify" readonly v-validate="'required'" :loading="submitting"
                            @click:append="showFundHelpList = true"></v-text-field>
                        </v-flex>
                        <v-flex xs12 md6 v-show="true">
                          <v-checkbox v-model="form.combineFundsReport" :label="labels.combineFundsReport"
                            data-vv-name="combineFundsReport" :data-vv-as="labels.combineFundsReport"></v-checkbox>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-container>
            </v-expansion-panel-content>
          </v-expansion-panel>
          </v-expansion-panels>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-checkbox color="primary" :label="labels.rptParam" v-model="form.rptParam"></v-checkbox>
          <!-- <v-btn color="info" :loading="submitting" @click.prevent="doSchedule">
                    <v-icon left dark>mdi-clock</v-icon>
                    {{labels.schedule}}
                  </v-btn> -->
          <v-btn class="mr-2" color="primary" type="submit" :loading="submitting" @click.prevent="doExport">
            <v-icon left dark>mdi-file-export</v-icon>
            {{ labels.export }}
          </v-btn>
          <v-btn-toggle dense mandatory v-model="form.format">
            <v-btn text v-for="format in supportedList" :key="format.value" :value="format.value">
              <span>{{ format.label }}</span>
              <v-icon :color="format.color">{{ format.icon }}</v-icon>
            </v-btn>
          </v-btn-toggle>
        </v-flex>
      </v-layout>
    </v-container>
    <v-dialog v-model="showAcctPeriodHelpList" width="1280px">
      <acct-period-help-list2 @close="showAcctPeriodHelpList = false" @assign-acct-period-info="doAssign($event)"
        :boolRefresh="showAcctPeriodHelpList" :modeNo="modeNo"></acct-period-help-list2>
    </v-dialog>
    <v-dialog v-model="showFundHelpList" width="900px" persistent>
      <multi-fund-help-list :fnd="form.fund" @close="doClose" @doAssign="doAssignFund($event)" />
    </v-dialog>
    <v-dialog v-model="scheduleJobModal" width="1000px" persistent>
      <ScheduleJob @close="scheduleJobModal = false" :jobName="jobName" :jobDesc="jobDesc"></ScheduleJob>
    </v-dialog>
  </page>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { reportFormat } from '@/const/report'
import MessageMixin from '@/mixins/message'
import MultiFundHelpList from '@/components/core/common/dialog/MultiFundHelpList.vue'
import AcctPeriodHelpList2 from '@/components/core/common/dialog/AcctPeriodHelpList2'
import ScheduleJob from '@/components/core/common/dialog/ScheduleJob'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'

export default {
  data() {
    return {
      labels: {
        acctPerFrom: 'Accounting Period From',
        acctPerTo: 'Accounting Period To',
        format: 'Export Format',
        export: 'Export to',
        schedule: 'Schedule',
        fund: 'Funds',
        combineFundsReport: 'Combine Funds Report',
        cancel: 'Cancel',
        rptParam: 'Print Runtime Parameters'
      },
      form: {
        acctPerFrom: '',
        acctPerTo: '',
        format: 'PDF',
        fund: 'All',
        combineFundsReport: false,
        acctPeriod: '',
        rptParam: true
      },
      menu: {},
      supportedFormat: [],
      acctPeriodList: [],
      submitting: false,
      modeNo: '3',
      mode: '',
      showFundHelpList: false,
      showAcctPeriodHelpList: false,
      scheduleJobModal: false,
      jobName: 'qrtzGrossRICeStat',
      jobDesc: 'Gross & RI Ceded Statistics',
      panel1: [0]
    }
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.accountReports.menu
    },
    supportedList() {
      const result = []
      if (this.supportedFormat && this.supportedFormat.length > 0) {
        this.supportedFormat.map(format => {
          if (reportFormat[format]) {
            result.push(reportFormat[format])
          }
        })
      }
      return result
    }
  },
  watch: {
    'supportedList': function (value) {
      if (value && value.length > 0) {
        // Default the 1st value
        this.form.format = value[0].value
      }
    }
  },
  created() {
    this.doInit()

    this.$validator.extend('acctPerRangeFrom', {
      getMessage(field, args) {
        return field + ' must less than or equal To Accouting Period'
      },
      validate(value, args) {
        let tAcctPerFrom = value.split('/')
        let acctPerFrom = ''
        if (tAcctPerFrom[0].length === 1) {
          acctPerFrom = tAcctPerFrom[1] + '0' + tAcctPerFrom[0]
        } else {
          acctPerFrom = tAcctPerFrom[1] + tAcctPerFrom[0]
        }
        let tAcctPerTo = args[0].split('/')
        let acctPerTo = ''
        if (tAcctPerTo[0].length === 1) {
          acctPerTo = tAcctPerTo[1] + '0' + tAcctPerTo[0]
        } else {
          acctPerTo = tAcctPerTo[1] + tAcctPerTo[0]
        }
        if (parseInt(acctPerFrom) > parseInt(acctPerTo)) {
          return false
        } else {
          return true
        }
      }
    })

    this.$validator.extend('acctPerRangeTo', {
      getMessage(field, args) {
        return field + ' must greater than or equal From Accouting Period'
      },
      validate(value, args) {
        let tAcctPerFrom = args[0].split('/')
        let acctPerFrom = ''
        if (tAcctPerFrom[0].length === 1) {
          acctPerFrom = tAcctPerFrom[1] + '0' + tAcctPerFrom[0]
        } else {
          acctPerFrom = tAcctPerFrom[1] + tAcctPerFrom[0]
        }
        let tAcctPerTo = value.split('/')
        let acctPerTo = ''
        if (tAcctPerTo[0].length === 1) {
          acctPerTo = tAcctPerTo[1] + '0' + tAcctPerTo[0]
        } else {
          acctPerTo = tAcctPerTo[1] + tAcctPerTo[0]
        }
        if (parseInt(acctPerTo) < parseInt(acctPerFrom)) {
          return false
        } else {
          return true
        }
      }
    })
  },
  methods: {
    async doClose() {
      this.showFundHelpList = false
    },
    async doAssignFund(obj) {
      this.form.fund = []
      this.form.fund = obj.finalSelectedItems.toString()
    },
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getAcctPeriods(this.modeNo).then(result => {
        const today = new Date()
        const year = today.getFullYear()
        const month = today.getMonth() + 1
        for (let ap of this.acctPeriodList) {
          if (ap.acctPerMth === month && ap.acctPerYr === year) {
            this.form.acctPeriod = ap.acctPerEndDate
            this.form.acctPerFrom = ap.acctPerMth + '/' + ap.acctPerYr
            this.form.acctPerTo = ap.acctPerMth + '/' + ap.acctPerYr
          }
        }
      })
      try {
        if (this.$store.state.reports.accountReports.init !== 1) {
          await this.$store.dispatch('accountReportsInit')
        }
        const apiURI = this.rptMenu.grossRICeStat
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result.data
          if (data) {
            this.supportedFormat = data.format
            this.menu = extractMenu(result.data._links)
          }
        }
      } catch (err) {
        throw err
      }
    },
    getHelpList(fieldName) {
      this.mode = fieldName
      switch (fieldName) {
        case 'acctPerFrom':
        case 'acctPerTo':
          this.showAcctPeriodHelpList = true
          break
      }
    },
    doAssign(data) {
      switch (this.mode) {
        case 'acctPerFrom':
          this.form.acctPerFrom = data.acctPerMth + '/' + data.acctPerYr
          break
        case 'acctPerTo':
          this.form.acctPerTo = data.acctPerMth + '/' + data.acctPerYr
          break
      }
    },
    doExport() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.processExport()
        }
      })
    },
    async processExport() {
      const apiURI = this.menu.exportGrRICeStat
      if (apiURI) {
        try {
          this.submitting = true
          await this.$http.post(apiURI, this.form)
          this.submitting = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.submitting = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doCancel() {
      this.$router.push({ name: 'reportAcct' })
    },
    doSchedule() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.scheduleJobModal = true
        }
      })
    },
    acctPeriodValidate(fieldName) {
      if (fieldName === 'acctPerFrom') {
        return 'required|acctPerRangeFrom:' + this.form.acctPerTo
      } else {
        return 'required|acctPerRangeTo:' + this.form.acctPerFrom
      }
    }
  },
  mixins: [
    MessageMixin,
    commonAjaxMixin
  ],
  components: {
    AcctPeriodHelpList2,
    MultiFundHelpList,
    ScheduleJob
  }
}

</script>
